import { h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import clsx from 'clsx';
import { getProductByHandle } from '../utils/storefront/get-products';
import Price from '../product/product-price';
import Image from '../utils/image';
import { formatMetaobjectList } from '../utils/helpers';
import { formatProduct } from '../utils/storefront/format-resource';
import YotpoStars from '../product/product-stars';
import ScentColors from '../product/product-scent-colors';
import AddToCartButton from '../product/product-add-to-cart';

const Product = ({ settings }) => {
  const { product, image, image_position: imagePosition, video } = settings;
  const [productData, setProductData] = useState({});
  const [currentVariant, setCurrentVariant] = useState({});
  const [scentColors, setScentColors] = useState([]);
  const [isKits, setIsKits] = useState(false);
  const [customPromotions, setCustomPromotions] = useState([]);
  const [compareAtPriceBadge, setCompareAtPriceBadge] = useState('');
  const productPopup = useRef();

  useEffect(() => {
    if (!product) return;
    async function getProduct() {
      const products = await getProductByHandle(product);

      if (products?.data?.productByHandle)
        setProductData(products?.data?.productByHandle);
    }
    getProduct();
  }, [product]);

  useEffect(() => {
    setScentColors(
      formatMetaobjectList(productData?.scentColors?.references?.edges),
    );
    setCurrentVariant(
      productData?.variants?.edges[0] && productData?.variants?.edges[0].node,
    );

    const kitOptionGroups = [
      {
        products:
          productData?.kitOptionGroup1?.references?.nodes.map(formatProduct),
        label: productData?.kitOptionGroup1Label?.value,
        key: 'kitOptionGroup1',
      },
    ];
    // eslint-disable-next-line no-unused-expressions
    !kitOptionGroups[0].products ? setIsKits(false) : setIsKits(true);

    setCompareAtPriceBadge(productData?.compareAtPriceBadge?.value);
  }, [productData]);

  useEffect(() => {
    setCustomPromotions(
      currentVariant?.compareAtPrice === null &&
        productData?.compareAtPriceBadge?.value === 'false'
        ? productData?.excludePromo?.value
        : 'false',
    );
  }, [currentVariant, productData]);

  return (
    product && productData?.handle && (
      <div
        className={clsx(
          'flex group laptop:block relative col-span-2 laptop:col-span-1 aspect-[2] laptop:aspect-square',
          imagePosition,
        )}
      >
        <a
          className="h-full object-cover w-1/2 laptop:w-full block"
          href={`/products/${productData?.handle}`}
        >
          {image && <Image
            src={image}
            classes="h-full object-cover w-full"
            alt={product.title}
            srcWidths={{ sm: 380, md: 600, lg: 720, xl: 1280, '2xl': 1536 }}
          />}
          {video && (
            <div className="absolute inset-0 w-full h-full">
              <video
                loop
                muted
                autoPlay
                playsInline
                className="w-full h-full object-cover"
              >
                {video.sources.map((source, index) => (
                  <source
                    key={index}
                    src={source.url}
                    type={source.mime_type}
                  ></source>
                ))}
              </video>
            </div>
          )}
        </a>
        <button
          type="button"
          aria-label="See Product"
          className="hidden text-white laptop:flex items-center justify-center absolute w-[35px] h-[35px] rounded-full border border-white right-2.5 bottom-2.5 before:absolute before:top-1/2 before:-translate-y-1/2 before:w-3.5 before:border-b before:border-white after:absolute after:top-1/2 after:rotate-90 after:origin-center after:-translate-y-1/2 after:w-3.5 after:border-b after:border-white"
        ></button>
        <div
          ref={productPopup}
          className="h-full w-1/2 laptop:w-full flex flex-col justify-center laptop:block laptop:absolute laptop:group-hover:visible laptop:group-hover:opacity-100 laptop:invisible laptop:opacity-0 laptop:left-0 laptop:right-0 laptop:bottom-0 laptop:h-auto bg-cream-grey py-4 laptop:py-5 px-5"
        >
          {productData.id && (
            <div className="mb-2 laptop:mb-3 [&_.star-clickable>a]:hidden">
              <a href={`/products/${productData.handle}`}>
                <YotpoStars
                  currentProduct={productData}
                  currentVariant={currentVariant}
                />
              </a>
            </div>
          )}
          <ScentColors
            scentColors={scentColors}
            isProductCard={true}
            customClass="!mb-1.5 laptop:!mb-2"
          />
          <div className="product-title mb-1.5 laptop:mb-2">
            <a
              className="text-black font-14"
              href={`/products/${productData.handle}`}
            >
              {productData?.title}
            </a>
          </div>
          <Price
            currentPrice={currentVariant?.price}
            currentComparePrice={currentVariant?.compareAtPrice}
            fontClass="font-13 text-charcoal"
            customContainerClass="laptop:hidden mb-3"
            customPromotions={customPromotions}
            compareAtPriceBadge={compareAtPriceBadge}
          />
          <AddToCartButton
            data-product-card
            currentVariant={currentVariant}
            currentProduct={productData}
            showQty={false}
            showPrice={true}
            isKits={isKits}
            isMargin={false}
            showMessage={false}
            isProductCard={true}
            btnStyle="cta-small laptop:btn-primary"
            customClass="laptop:w-full"
            hidePriceMobile={true}
            customButtonClass="underline tracking-[0.02em] laptop:no-underline before:-bottom-0.5 before:opacity-30 inline-block w-auto laptop:w-full laptop:flex !py-0 laptop:!py-[14.5px]"
          />
        </div>
      </div>
    )
  );
};

export default Product;
